<template>
  <div class="comp-container" :class="{ 'comp-container__h5': isH5 }">
    <div class="back" @click="goBack">
      <img :src="arrowLeftImg" alt="" />返回
    </div>
    <div class="code-content">
      <div class="title">
        <h3>输入手机号验证码</h3>
        <p v-show="!verifyRes">
          请输入发送至
          <strong
            ><span>{{ showPhone }}</span></strong
          >
          的6位验证码，有效期5分钟
        </p>
        <p v-show="verifyRes">{{ verifyRes }}</p>
      </div>
      <div class="code-container">
        <input-num
          ref="inputNum"
          :disabled="isVerifying || isLoadingQRCode"
          :default-value="defaultCode"
          @inputOver="inputOver"
        />
        <el-button
          class="refresh-btn"
          :class="{ 'refresh-btn-disabled': !!timeNum }"
          type="text"
          :loading="isLoadingQRCode"
          :disabled="!!timeNum || isLoadingQRCode || isVerifying"
          @click="refreshQRCode"
        >
          {{ refreshText }}
        </el-button>
        <br />
      </div>
    </div>
    <div class="footer">
      <!-- <el-button
        type="primary"
        class="next-step"
        :disabled="nextStepDisabled"
        @click="nextStep"
        >下一步</el-button
      > -->
    </div>
  </div>
</template>

<script>
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify";
import Login from "@saas/components/src/mixins/login";
import InputNum from "./InputNum";
import { mapState } from "vuex";
import { isH5 } from "@saas/components/src";
import { uploadLiveLog, forceFlushLogs } from "@saas/components/src/utils/log";
export default {
  components: {
    InputNum,
  },
  mixins: [ManMachineVerify, Login],
  props: {
    // login 登录 register 注册
    type: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      arrowLeftImg: require("../../../assets/images/login/arrow-left.png"),
      // 验证结果
      verifyRes: "",
      // 是否验证中
      isVerifying: false,
      code: "",
      // 是否请求验证码中
      isLoadingQRCode: false,
      timer: null,
      timeNum: 60,
      defaultCode: ["", "", "", "", "", ""],
      isH5: isH5(),
      //   returnUrl: null
    };
  },
  computed: {
    ...mapState("user", ["loginForm"]),
    nextStepDisabled() {
      return this.code.length !== 6;
    },
    refreshText() {
      return this.timeNum
        ? `${this.timeNum}秒后可重新获取验证码`
        : "重新获取验证码";
    },
    showPhone() {
      // 中间四位
      const num = this.loginForm.mobile;
      return num.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  mounted() {
    this.startTimer();
    // this.returnUrl = this.$route.query.return_url || ''

    // 上传日志：验证码输入页加载
    uploadLiveLog({
      message: "验证码输入页加载",
      module: "login",
      level: "info",
      tag: "pageLoad",
      extra: {
        component: "InputCode",
        type: this.type,
        account: this.loginForm.mobile,
        regionNum: this.loginForm.region_num,
      },
    });
  },
  beforeDestroy() {
    // 页面销毁前上传所有日志
    forceFlushLogs().catch((err) => {
      console.error("页面销毁前上传日志失败:", err);
    });
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeNum > 0) {
          this.timeNum--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    nextStep() {
      this.isVerifying = true;

      // 上传日志：验证码登录开始
      uploadLiveLog(
        {
          message: "验证码登录开始",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "InputCode",
            type: this.type,
            account: this.loginForm.mobile,
            regionNum: this.loginForm.region_num,
          },
        },
        true
      );

      if (this.type === "login") {
        // 验证码登录
        this.$store
          .dispatch("user/loginByCode", {
            account: this.loginForm.mobile,
            region_num: this.loginForm.region_num
              ? this.loginForm.region_num + ""
              : "",
            code: this.code,
          })
          .then(({ code, message }) => {
            this.isVerifying = false;
            this.code = "";
            this.$refs["inputNum"].resetEmpty();
            if (code === 1) {
              // 上传日志：验证码登录成功
              uploadLiveLog(
                {
                  message: "验证码登录成功",
                  module: "login",
                  level: "info",
                  tag: "userAction",
                  extra: {
                    component: "InputCode",
                    type: this.type,
                    account: this.loginForm.mobile,
                  },
                },
                true
              );

              this.checkIdentity().then((isIdentity) => {
                if (isIdentity) {
                  // 上传日志：身份验证通过
                  uploadLiveLog(
                    {
                      message: "身份验证通过，登录完成",
                      module: "login",
                      level: "info",
                      tag: "userAction",
                      extra: {
                        component: "InputCode",
                        type: this.type,
                      },
                    },
                    true
                  );

                  // 登录成功后立即上传日志
                  forceFlushLogs().catch((err) => {
                    console.error("登录成功后上传日志失败:", err);
                  });

                  this.loginSuccess();
                  this.$message.success("登录成功");
                } else {
                  // 上传日志：需要选择身份
                  uploadLiveLog(
                    {
                      message: "需要选择身份",
                      module: "login",
                      level: "info",
                      tag: "userAction",
                      extra: {
                        component: "InputCode",
                        type: this.type,
                      },
                    },
                    true
                  );
                  this.$emit("goSelectIdentity");
                }
              });
            } else if (code === 20005 || code === 20003) {
              // 上传日志：验证码错误或过期
              uploadLiveLog(
                {
                  message: "验证码错误或过期",
                  module: "login",
                  level: "error",
                  tag: "userAction",
                  extra: {
                    component: "InputCode",
                    type: this.type,
                    account: this.loginForm.mobile,
                    errorCode: code,
                    errorMessage: message,
                  },
                },
                true
              );
              this.verifyRes = message;
            } else if (code === 20000) {
              // 用户不存在
              // 上传日志：用户不存在
              uploadLiveLog(
                {
                  message: "验证码登录-用户不存在",
                  module: "login",
                  level: "info",
                  tag: "userAction",
                  extra: {
                    component: "InputCode",
                    type: this.type,
                    account: this.loginForm.mobile,
                    errorCode: code,
                  },
                },
                true
              );
              this.$emit("accountNotExist");
            } else {
              // 上传日志：验证码登录失败
              uploadLiveLog(
                {
                  message: "验证码登录失败",
                  module: "login",
                  level: "error",
                  tag: "userAction",
                  extra: {
                    component: "InputCode",
                    type: this.type,
                    account: this.loginForm.mobile,
                    errorCode: code,
                    errorMessage: message,
                  },
                },
                true
              );
            }
          })
          .catch((error) => {
            // 上传日志：验证码登录异常
            uploadLiveLog(
              {
                message: "验证码登录异常",
                module: "login",
                level: "error",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                  error: error?.message || String(error),
                },
              },
              true
            );
            this.isVerifying = false;
          });
      } else {
        this.checkVerifyCode();
      }
    },
    // 注册前校验验证码
    checkVerifyCode() {
      // 上传日志：校验验证码开始
      uploadLiveLog(
        {
          message: "校验验证码开始",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "InputCode",
            type: this.type,
            account: this.loginForm.mobile,
          },
        },
        true
      );

      this.$store
        .dispatch("user/checkVerifyCode", {
          account: this.loginForm.mobile,
          code: this.code,
          scene: "QuickLogin",
          scene_str: this.loginForm.sceneStr,
        })
        .then((res) => {
          this.isVerifying = false;
          if (res.code === 1) {
            // 代表已注册过
            // 上传日志：校验验证码成功
            uploadLiveLog(
              {
                message: "校验验证码成功",
                module: "login",
                level: "info",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                  hasToken: !!(res.data.access_token && res.data.refresh_token),
                },
              },
              true
            );

            if (res.data.access_token && res.data.refresh_token) {
              this.checkIdentity().then((isIdentity) => {
                if (isIdentity) {
                  // 上传日志：身份验证通过
                  uploadLiveLog(
                    {
                      message: "身份验证通过，登录完成",
                      module: "login",
                      level: "info",
                      tag: "userAction",
                      extra: {
                        component: "InputCode",
                        type: this.type,
                      },
                    },
                    true
                  );
                  this.loginSuccess();
                } else {
                  // 上传日志：需要选择身份
                  uploadLiveLog(
                    {
                      message: "需要选择身份",
                      module: "login",
                      level: "info",
                      tag: "userAction",
                      extra: {
                        component: "InputCode",
                        type: this.type,
                      },
                    },
                    true
                  );
                  this.$emit("goSelectIdentity");
                }
              });
            } else {
              // 上传日志：需要设置密码
              uploadLiveLog(
                {
                  message: "需要设置密码",
                  module: "login",
                  level: "info",
                  tag: "userAction",
                  extra: {
                    component: "InputCode",
                    type: this.type,
                    account: this.loginForm.mobile,
                  },
                },
                true
              );
              this.$emit("accountNotExist");
            }
          } else if (res.code === 20005 || res.code === 20004) {
            // 验证码已使用或者过期
            // 上传日志：验证码已使用或过期
            uploadLiveLog(
              {
                message: "验证码已使用或过期",
                module: "login",
                level: "error",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                  errorCode: res.code,
                  errorMessage: res.message,
                },
              },
              true
            );
            this.$message.error(res.message);
            this.$emit("codeError");
          } else if (res.code === 20003) {
            // 上传日志：验证码错误
            uploadLiveLog(
              {
                message: "验证码错误",
                module: "login",
                level: "error",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                  errorCode: res.code,
                },
              },
              true
            );
            this.$message.error("验证码错误, 请重新输入");
          } else {
            // 上传日志：校验验证码失败
            uploadLiveLog(
              {
                message: "校验验证码失败",
                module: "login",
                level: "error",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                  errorCode: res.code,
                  errorMessage: res.message,
                },
              },
              true
            );
          }
        })
        .catch((error) => {
          // 上传日志：校验验证码异常
          uploadLiveLog(
            {
              message: "校验验证码异常",
              module: "login",
              level: "error",
              tag: "userAction",
              extra: {
                component: "InputCode",
                type: this.type,
                account: this.loginForm.mobile,
                error: error?.message || String(error),
              },
            },
            true
          );
          this.isVerifying = false;
        });
    },
    inputOver(val) {
      this.code = val;
      //   this.isVerifying = true
      this.$store.commit("user/SET_LOGIN_FORM", {
        mobile: this.loginForm.mobile,
        code: this.code,
      });
      this.nextStep();
    },
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      // 上传日志：重新发送验证码
      uploadLiveLog(
        {
          message: "重新发送验证码",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "InputCode",
            type: this.type,
            account: this.loginForm.mobile,
            regionNum: this.loginForm.region_num,
          },
        },
        true
      );

      this.$store
        .dispatch("user/sendCode", {
          account: this.loginForm.mobile,
          region_num: this.loginForm.region_num
            ? this.loginForm.region_num + ""
            : "",
          randstr: res.randstr,
          scene: "QuickLogin",
          ticket: res.ticket,
        })
        .then((res) => {
          if (res.code === 1) {
            // 上传日志：重新发送验证码成功
            uploadLiveLog(
              {
                message: "重新发送验证码成功",
                module: "login",
                level: "info",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                },
              },
              true
            );
            this.timeNum = 60;
            this.startTimer();
          } else {
            // 上传日志：重新发送验证码失败
            uploadLiveLog(
              {
                message: "重新发送验证码失败",
                module: "login",
                level: "error",
                tag: "userAction",
                extra: {
                  component: "InputCode",
                  type: this.type,
                  account: this.loginForm.mobile,
                  errorCode: res.code,
                  errorMessage: res.message,
                },
              },
              true
            );
          }
          this.isLoadingQRCode = false;
        })
        .catch((error) => {
          // 上传日志：重新发送验证码异常
          uploadLiveLog(
            {
              message: "重新发送验证码异常",
              module: "login",
              level: "error",
              tag: "userAction",
              extra: {
                component: "InputCode",
                type: this.type,
                account: this.loginForm.mobile,
                error: error?.message || String(error),
              },
            },
            true
          );
          this.isLoadingQRCode = false;
        });
    },
    // 重新获取验证码
    refreshQRCode() {
      this.isLoadingQRCode = true;
      this.$refs["inputNum"].resetEmpty();
      this.showCaptcha();
    },
    // 切换密码验证
    switchPasswordVerigy() {},
    goBack() {
      // 上传日志：返回操作
      uploadLiveLog(
        {
          message: "验证码输入页返回",
          module: "login",
          level: "info",
          tag: "userAction",
          extra: {
            component: "InputCode",
            type: this.type,
          },
        },
        true
      );
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 480px;
  height: 550px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 55px 20px 50px 20px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(156, 175, 154, 0.17);
  border-radius: 24px;
  .back {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
  .code-content {
    flex: 1;
    margin: 0;
    margin-top: 16px;
    .title {
      h3 {
        font-weight: 500;
        margin: 0;
        font-size: 24px;
        color: $saas-text-color;
        line-height: 33px;
      }
      p {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        height: 22px;
        margin-top: 8px;
        &:last-child {
          color: #f03349;
        }
        span {
          color: rgba(13, 20, 0, 1);
          font-weight: normal;
        }
      }
    }
    .code-container {
      margin-top: 30px;
      
      .refresh-btn {
        font-weight: normal;
        font-size: 14px;
        margin-top: 16px;
        color: rgba(0, 200, 157, 1);
      }
      .refresh-btn-disabled {
        color: #515350;
      }
      .el-button {
        margin-bottom: 8px;
        padding: 5px 0;
      }
    }
  }
  .footer {
    width: 100%;
    padding-right: 48px;
    .next-step {
      width: 100%;
      height: 50px;
      border-radius: 16px !important;
      border: none;
      font-weight: 600;
      font-size: 16px;
      background: linear-gradient(
        132deg,
        rgba(0, 235, 129, 1) 0%,
        rgba(0, 200, 157, 1) 100%
      ) !important;
      color: #fff !important;
      &:hover {
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
        color: #fff !important;
      }
      &:focus {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &.is-disabled {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 0.5) 0%,
          rgba(0, 200, 157, 0.5) 100%
        ) !important;
        &:hover {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
        &:focus {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
      }
    }
  }
}
.comp-container__h5 {
  width: 100%;
  height: 100%;
  padding: 0.3067rem 0 0.6667rem 0.64rem;
  box-shadow: none;
  border-radius: 0;
  .back {
    position: absolute;
    left: 0.5067rem;
    top: 0.4rem;
    font-size: 0.4267rem;
    line-height: 0.6rem;
    img {
      width: 0.4267rem;
      height: 0.4267rem;
      margin-right: 0.16rem;
    }
  }
  .code-content {
    margin: 0;
    margin-top: 2.4rem;
    .title {
      h3 {
        font-size: 0.5333rem;
        line-height: 0.7467rem;
      }
      p {
        font-size: 0.3467rem;
        line-height: 0.4933rem;
        height: 0.4933rem;
        margin-top: 0.2667rem;
      }
    }
    .code-container {
      margin-top: 1.2rem;
      padding-right: 0.6667rem;
      .refresh-btn {
        margin-top: 0.4rem;
        font-size: 0.3467rem;
      }
      .el-button {
        margin-bottom: 1.3867rem;
      }
    }
  }
  .footer {
    width: 100%;
    padding-right: 0.6667rem;
    .next-step {
      width: 100%;
      height: 1.3333rem;
      font-size: 0.4267rem;
      border-radius: 0.4267rem !important;
    }
  }
}

@keyframes identifier {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
